import React from "react";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import useStyles from "./papperStyle-jss";

function PapperBlock(props) {
  const { classes, cx } = useStyles();
  const {
    title,
    desc,
    children,
    rewardValue,
    whiteBg,
    noMargin,
    colorMode,
    overflowX,
    icon,
    navLink,
    referralComponent,
    textposition = "default",
  } = props;

  const localhref = window.location.pathname;
  const getDashboard = localhref.split("/")[2];
  const hasDashboard = getDashboard.includes("dashboard");
  // console.log("title", title);

  const iseaTitle = "ISEA - Key Verticals";
  const trainingTitle = "My Trainings";

  // console.log("vndvndkv", hasDashboard);

  return (
    <div className={classes.borderPaperblock}>
      <Paper
        className={` mb-0  ${
          !!(title === iseaTitle) ? classes.dashboardLink : ""
        } ${cx(
          classes.root,
          noMargin && classes.noMargin,
          colorMode && classes.colorMode
        )}`}
        elevation={0}
      >
        <div className={`   ${classes.descBlock}`}>
          <span className={classes.iconTitle}>
            <i className={icon} />
          </span>
          <div
            className={`  ${
              !!(title === iseaTitle) ? classes.iseaTitleText : ""
            }  ${classes.titleText}`}
          >
            <Typography variant="h6" component="h2" className={classes.title}>
              {title}
            </Typography>
            <Typography component="p" className={classes.description}>
              {desc}
            </Typography>
          </div>
          <div className={classes.rewardPointsValue}>
            <Typography variant="h6" component="h2" className={classes.title}>
              <div className={classes.rewardPoints}>{rewardValue}</div>
            </Typography>
          </div>
          <div className={classes.papperBtn}>
            <Typography variant="p" component="p" className={classes.navLinks}>
              {navLink}
            </Typography>
          </div>
          <div className={classes.papperBtn}>
            <Typography variant="p" component="p" className={classes.navLinks}>
              {referralComponent}
            </Typography>
          </div>
        </div>
        <section
          className={` p-0 ${cx(
            classes.content,
            whiteBg && classes.whiteBg,
            overflowX && classes.overflowX
          )}`}
        >
          {children}
        </section>
      </Paper>
    </div>
  );
}

PapperBlock.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
  whiteBg: PropTypes.bool,
  colorMode: PropTypes.bool,
  noMargin: PropTypes.bool,
  overflowX: PropTypes.bool,
};

PapperBlock.defaultProps = {
  whiteBg: false,
  noMargin: false,
  colorMode: false,
  overflowX: false,
  icon: "ion-ios-bookmark-outline",
};

export default PapperBlock;
